import Component from '../../../shared/component';

const WITH_FILE_CLASS = 'messageForm-fieldContainer--with-file';

export default class ConversationUploadButton extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$input = this.$element.find('.messageForm-uploadInput');
    this.$button = this.$element.find('.messageForm-uploadButton');
    this.$fileName = this.$element.find('.messageForm-selectedFile-name');
    this.$removeButton = this.$element.find('.messageForm-selectedFile-remove');

    this.maxFileSize = this.$button.data('max-file-size');
    this.maxFileSizeExceededMessage = this.$button.data(
      'max-file-size-exceeded-message'
    );
  }

  bindEvents() {
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleAttachmentRemove = this.handleAttachmentRemove.bind(this);

    this.$input.on('change.ConversationUploadButton', this.handleFileChange);
    this.$removeButton.on(
      'click.ConversationUploadButton',
      this.handleAttachmentRemove
    );
  }

  unbindEvents() {
    this.$input.off('change.ConversationUploadButton', this.handleFileChange);
    this.$removeButton.off(
      'click.ConversationUploadButton',
      this.handleAttachmentRemove
    );
  }

  handleFileChange(event) {
    if (event.target.files[0].size > this.maxFileSize) {
      // eslint-disable-next-line no-alert
      alert(this.maxFileSizeExceededMessage);
      this.removeAttachment();

      return;
    }

    this.addAttachment(this.$input.val());
  }

  handleAttachmentRemove() {
    this.removeAttachment();
  }

  addAttachment(filename) {
    this.$element.addClass(WITH_FILE_CLASS);
    this.$fileName.html(filename.split(/(\\|\/)/g).pop());
  }

  removeAttachment() {
    this.$element.removeClass(WITH_FILE_CLASS);
    this.$fileName.html('');
    this.$input.val('');
  }
}
